<div class="workflow-form-main">
  <h2 class="workflow-title text-3xl font-semibold mb-4">
    {{ 'workflows.save_photos' | translate }}
  </h2>

  <div class="photos-container">
    @for (photo of photoFiles(); track photo.id) {
      @let status = photo.status;
      <div class="photo-wrapper">
        <tui-loader [loading]="shouldShowLoader(status)" [inheritColor]="true">
          <img
            [src]="photo | fileUrl"
            alt="Фото"
            class="photo-preview"
            [class.opacity-40]="shouldShowLoader(status)"
            [class.opacity-80]="isQueuedOfflineUpload(status)"
            [class.opacity-55]="isQueuedOfflineRemove(status)"
            [class.opacity-30]="
              status === 'upload_error' || status === 'remove_error'
            "
            [class.cursor-pointer]="canOpenPreview(status)"
            (click)="onPhotoClick($index, status)"
          />

          @if (isQueuedOfflineUpload(status)) {
            <span
              class="queue-hint-surface queue-upload"
              [tuiHint]="'workflows.offline_upload_pending_hint' | translate"
              tuiHintAppearance="dark"
            >
              <span class="queue-badge">
                {{ 'workflows.offline_upload_pending' | translate }}
              </span>
            </span>
          }

          @if (isQueuedOfflineRemove(status)) {
            <span
              class="queue-hint-surface queue-remove"
              [tuiHint]="'workflows.offline_remove_pending_hint' | translate"
              tuiHintAppearance="dark"
            >
              <span class="queue-badge">
                {{ 'workflows.offline_remove_pending' | translate }}
              </span>
            </span>
          }

          @if (status === 'upload_error') {
            <div
              class="photo-error-overlay"
              [tuiHint]="'workflows.photo_queue_upload_failed_hint' | translate"
              tuiHintAppearance="dark"
            >
              <button
                tuiIconButton
                appearance="flat"
                class="retry-button"
                (click)="retryUpload(photo)"
                iconStart="@tui.refresh-cw"
                size="xs"
                type="button"
                [title]="'workflows.retry_file_upload' | translate"
              ></button>
            </div>
          }

          @if (status === 'remove_error') {
            <div
              class="photo-error-overlay actions-row"
              [tuiHint]="'workflows.photo_queue_remove_failed_hint' | translate"
              tuiHintAppearance="dark"
            >
              <button
                tuiIconButton
                appearance="flat"
                class="retry-button"
                (click)="retryRemove(photo)"
                iconStart="@tui.refresh-cw"
                size="xs"
                type="button"
                [title]="'workflows.retry_file_deletion' | translate"
              ></button>
              <button
                tuiIconButton
                appearance="flat"
                class="dismiss-button"
                (click)="dismissRemoveError(photo)"
                iconStart="@tui.check"
                size="xs"
                type="button"
                [title]="'workflows.dismiss_error' | translate"
              ></button>
            </div>
          }

          @if (canExecuteWorkflow() && canRemoveFile(status)) {
            <button
              tuiButton
              appearance="flat"
              class="delete-button"
              (click)="confirmRemoveFile(photo)"
              shape="square"
              size="xs"
              type="button"
              [title]="
                status === 'queued_upload'
                  ? ('workflows.cancel_queued_upload' | translate)
                  : ''
              "
            >
              <!--              В оффлайн режиме мы не можем использовать tuiIconButton поэтому рисуем svg-->
              <svg
                class="delete-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                aria-hidden="true"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="m15 9-6 6M9 9l6 6" />
              </svg>
            </button>
          }
        </tui-loader>
      </div>
    }
  </div>
</div>

<div class="workflow-form-footer">
  @if (field()?.allowFromCamera) {
    <input
      class="hidden"
      #cameraInput
      type="file"
      [accept]="$accept()"
      capture="environment"
      (change)="onFileSelected($event)"
    />

    <button
      tuiButton
      type="button"
      size="m"
      class="workflow-btn w-full mt-4"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      [disabled]="!canExecuteWorkflow()"
      (click)="cameraInput.click()"
    >
      {{ 'workflows.take_more_photos' | translate }}
    </button>
  }

  @if (field()?.allowFromGallery) {
    <input
      class="hidden"
      #fileInput
      type="file"
      multiple
      [accept]="$accept()"
      (change)="onFileSelected($event)"
    />

    <button
      tuiButton
      type="button"
      size="m"
      class="workflow-btn w-full mt-4"
      appearance="outline-grayscale"
      tuiAppearanceMode="checked"
      [disabled]="!canExecuteWorkflow()"
      (click)="selectFiles()"
    >
      {{ 'workflows.upload_from_gallery' | translate }}
    </button>
  }

  <button
    tuiButton
    type="submit"
    size="m"
    class="workflow-btn w-full mt-4"
    appearance="primary"
    (click)="sync()"
  >
    {{ 'workflows.sync' | translate }}
  </button>
</div>

@let isMobile = deviceService.isMobile$ | async;
<ng-template #imagePreview let-observer>
  <tui-preview
    [rotatable]="true"
    [zoomable]="true"
    (click)="backdropClickClose($event, observer)"
    (tuiSwipe)="onSwipePreview($event)"
  >
    @if (currentFileName) {
      <tui-preview-title>{{ currentFileName }}</tui-preview-title>
    }
    <tui-preview-pagination
      [length]="previewLength()"
      [(index)]="currentPreviewIndex"
    ></tui-preview-pagination>
    <button
      iconStart="@tui.x"
      title="Close"
      tuiIconButton
      tuiPreviewAction
      type="button"
      (click)="closePreview(observer)"
    ></button>
    <img [alt]="currentFileName || ''" [src]="currentFile | fileUrl" />
    @if (isMobile) {
      <div
        class="mt-4 x-text-primary text-center absolute top-10"
        tuiPreviewAction
      >
        <h4 class="x-font-body-3-bold cursor-pointer">
          {{ currentFileName }}
        </h4>
      </div>
    }
  </tui-preview>
</ng-template>
